import * as R from 'ramda'
import { isActionType } from 'helpers/ramda-ext/actions'
import { createSelector } from 'reselect'
import * as Actions from 'store/actions'
import {
  GetEmptySaleResourcesErrors,
  GetErrors,
  GetErrorStatus,
  GetNetworkErrors,
  GetResourceFetchErrors,
  GetVersionFetchErrors
} from './errors.types'

export const getErrors: GetErrors = R.prop('errors')

export const getErrorStatus: GetErrorStatus = createSelector(
  getErrors,
  R.compose(
    R.path(['payload', 'error', 'status']),
    R.head
  )
)

export const getResourceFetchErrors: GetResourceFetchErrors = createSelector(
  getErrors,
  R.filter(isActionType(Actions.resources.FETCH_RESOURCE_ERROR))
)

export const getVersionFetchErrors: GetVersionFetchErrors = createSelector(
  getErrors,
  R.filter(isActionType(Actions.version.FETCH_VERSION_ERROR))
)

export const getNetworkErrors: GetNetworkErrors = createSelector(
  getErrors,
  R.filter(isActionType(Actions.errors.NETWORK_ERROR))
)

export const getEmptySaleResourcesErrors: GetEmptySaleResourcesErrors = createSelector(
  getErrors,
  R.filter(isActionType(Actions.resources.EMPTY_SALE_RESOURCES_ERROR))
)
